export enum LessonPlanEntityMutationActionType {
  UPDATE_ENTITY = 'LESSON_PLAN_MUTATION.UPDATE_ENTITY'
}
